import React, { useState, useEffect } from "react";
import {useTheme, withStyles} from "@mui/styles";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import AppAnimate from "../../components/AppAnimate";
import {connect, setStore} from "trim-redux";
import AppCard from "../../components/layout/components/AppCard";
import {Styles} from "../../../config/design/styles";
import RegisterNew from "./RegisterNew";
import {useTranslation} from "react-i18next";
import Logo from "../../components/elements/Logo";
import Title from "../../components/elements/Title";
import {Typography} from "@mui/material";
import Button from "@mui/material/Button";
import {ChevronLeft} from 'lucide-react';
import {removeLocalStorages} from "../../../config/values";
import ChevronBack from "../../components/icons/ChevronBack";
import clsx from "clsx";
const LoginWithToken = ({classes,user,isAuth}) => {

    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if (isAuth) {
            if(!!user?.id_number){
                navigate('/')
            }

        }
    }, [user,isAuth ]);

    const handleLogout = () => {
        removeLocalStorages()
        setStore({
            isAuth: false,
            user: null,
        });
        navigate('/login')
    };
    return (

        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('register')}>
            <div className={"authRegister"}>
                <AppCard

                >
                    <Grid container spacing={2} justifyContent={"center"} style={{marginTop:50}}>
                        <Grid item size={{xs:11}} style={{marginTop:10,marginBottom:10,position:"relative"}}>

                            <Typography>{t("completeYourInfo")}</Typography>
                        </Grid>
                        <Grid item size={{xs:11}}>
                            <RegisterNew
                                user_id={user?.id}
                            />
                        </Grid>
                        <Grid item size={11}>
                            <Button
                                onClick={() => handleLogout()}
                                startIcon={<ChevronBack className="lucide-icon"/>}
                                color="secondary"
                                size="small"
                            >
                                {t('back')}
                            </Button>
                        </Grid>
                    </Grid>
                </AppCard>
            </div>
        </AppAnimate>

    );
};
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
});

export default withStyles(Styles)(connect(mapStateToProps)(LoginWithToken));
